import colors from './colors';
/*!

 =========================================================
 * Material Kit PRO React - v1.2.0 based on Material Kit PRO - v2.0.3
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-kit-pro-react
 * Copyright 2018 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/ct-material-kit-pro-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

const drawerWidth = 260;

const transition = {
    transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
};
const isIE = !!document.documentMode;

const containerIE = isIE
    ? {
        '@media (min-width: 576px)': {
            width: '540px'
        },
        '@media (min-width: 768px)': {
            width: '720px'
        },
        '@media (min-width: 992px)': {
            width: '960px'
        },
        '@media (min-width: 1200px)': {
            width: '1140px'
        }
    }
    : {};

const containerFluid = {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%'
};
const container = {
    ...containerFluid,
    ...containerIE,
    '@media (min-width: 576px)': {
        maxWidth: '540px'
    },
    '@media (min-width: 768px)': {
        maxWidth: '720px'
    },
    '@media (min-width: 992px)': {
        maxWidth: '960px'
    },
    '@media (min-width: 1200px)': {
        maxWidth: '1140px'
    }
};

const boxShadow = {
    boxShadow:
        '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)'
};

const card = {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px 0',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    borderRadius: '3px',
    color: 'rgba(0, 0, 0, 0.87)',
    background: '#fff'
};

const defaultFont = {
    fontFamily: 'Jost',
    fontWeight: 400,
    lineHeight: '1.5em'
};

const primaryColor = colors.themeColors.primaryColor.hex();
const secondaryColor = colors.themeColors.secondaryColor.hex();
const warningColor = colors.themeColors.warningColor.hex();
const dangerColor = colors.themeColors.dangerColor.hex();
const successColor = colors.themeColors.successColor.hex();
const infoColor = colors.themeColors.infoColor.hex();
const roseColor = colors.themeColors.roseColor.hex();
const grayColor = colors.themeColors.grayColor.hex();

const primaryBoxShadow = {
    boxShadow: `0 12px 20px -10px ${colors.themeColors.primaryColor
        .alpha(0.28)
        .rgb()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${colors.themeColors.primaryColor.alpha(0.2).rgb()}`
};
const infoBoxShadow = {
    boxShadow: `0 12px 20px -10px ${colors.themeColors.infoColor
        .alpha(0.28)
        .rgb()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${colors.themeColors.infoColor.alpha(0.2).rgb()}`
};
const successBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(31, 198, 150, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(31, 198, 150, 0.2)`
};
const warningBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)`
};
const dangerBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)`
};
const roseBoxShadow = {
    boxShadow: `0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)`
};

const warningCardHeader = {
    color: '#fff',
    background: `linear-gradient(60deg, #ffa726, #fb8c00)`,
    ...warningBoxShadow
};
const successCardHeader = {
    color: '#fff',
    background: `linear-gradient(60deg, #66bb6a, #43a047)`,
    ...successBoxShadow
};
const dangerCardHeader = {
    color: '#fff',
    background: `linear-gradient(60deg, #ef5350, #e53935)`,
    ...dangerBoxShadow
};
const infoCardHeader = {
    color: '#fff',
    background: `linear-gradient(60deg, #26c6da, #00acc1)`,
    ...infoBoxShadow
};
const primaryCardHeader = {
    color: '#fff',
    background: `linear-gradient(60deg, #ab47bc, #8e24aa)`,
    ...primaryBoxShadow
};
const roseCardHeader = {
    color: '#fff',
    background: `linear-gradient(60deg, #ec407a, #d81b60)`,
    ...roseBoxShadow
};
const cardActions = {
    margin: '0 20px 10px',
    paddingTop: '10px',
    borderTop: '1px solid #eeeeee',
    height: 'auto',
    ...defaultFont
};

const cardHeader = {
    margin: '-30px 15px 0',
    borderRadius: '3px',
    padding: '15px'
};

const defaultBoxShadow = {
    border: '0',
    borderRadius: '3px',
    boxShadow:
        '0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    padding: '10px 0',
    transition: 'all 150ms ease 0s'
};

const title = {
    color: colors.themeColors.infoColor.hex(),
    textDecoration: 'none',
    fontWeight: '700',
    marginTop: '30px',
    marginBottom: '25px',
    minHeight: '32px',
    fontFamily: 'Jost'
};

const cardTitle = {
    '&, & a': {
        ...title,
        marginTop: '.625rem',
        marginBottom: '0.75rem',
        minHeight: 'auto'
    }
};

const cardLink = {
    '& + $cardLink': {
        marginLeft: '1.25rem'
    }
};

const cardSubtitle = {
    marginBottom: '0',
    marginTop: '-.375rem'
};

const main = {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: '3'
};

const mainRaised = {
    '@media (max-width: 576px)': {
        marginTop: '-30px'
    },
    '@media (max-width: 830px)': {
        marginLeft: '10px',
        marginRight: '10px'
    },
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow:
        '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)'
};

const section = {
    backgroundPosition: '50%',
    backgroundSize: 'cover'
};

const sectionDark = {
    backgroundColor: '#343434',
    background: 'radial-gradient(ellipse at center,#585858 0,#232323 100%)'
};

const sectionDescription = {
    marginTop: '130px'
};

const description = {
    color: '#999'
};

const mlAuto = {
    marginLeft: 'auto'
};

const mrAuto = {
    marginRight: 'auto'
};

const btnLink = {
    backgroundColor: 'transparent',
    boxShdow: 'none',
    marginTop: '5px',
    marginBottom: '5px'
};
const coloredShadow = {
    // some jss/css to make the cards look a bit better on Internet Explorer
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        display: 'none !important'
    },
    transform: 'scale(0.94)',
    top: '12px',
    filter: 'blur(12px)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    zIndex: '-1',
    transition: 'opacity .45s',
    opacity: 0
};

export {
    //variables
    drawerWidth,
    transition,
    container,
    containerFluid,
    boxShadow,
    card,
    defaultFont,
    primaryColor,
    secondaryColor,
    warningColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    grayColor,
    primaryBoxShadow,
    infoBoxShadow,
    successBoxShadow,
    warningBoxShadow,
    dangerBoxShadow,
    roseBoxShadow,
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    roseCardHeader,
    cardActions,
    cardHeader,
    defaultBoxShadow,
    title,
    cardTitle,
    description,
    cardLink,
    cardSubtitle,
    main,
    mainRaised,
    section,
    sectionDark,
    sectionDescription,
    mlAuto,
    mrAuto,
    btnLink,
    coloredShadow
};
